import React from 'react';
import TextVariableButton from '../TextVariableButton';
import {
  totalSlideShowScoreCallback,
  totalSlideShowScoreHtml,
} from './TotalSlideShowScore.utils';

type TotalSlideShowScoreProps = {
  editorInstance: any;
  locale?: 'en' | 'es';
};

const TotalSlideShowScore = ({ locale, editorInstance } : TotalSlideShowScoreProps) => {
  const html = editorInstance.el;
  const numberOfScoreVariables = html.querySelectorAll('.slide-show-score-variable').length + 1;

  return (
    <TextVariableButton
      label="Total Score (Slideshow)"
      onClick={e => totalSlideShowScoreCallback({
        e,
        editorInstance,
        htmlSnippets: {
          htmlEn: totalSlideShowScoreHtml({ locale: 'en', snippetNum: numberOfScoreVariables }),
          htmlEs: totalSlideShowScoreHtml({ locale: 'es', snippetNum: numberOfScoreVariables }),
        },
        locale,
      })}
    />
  );
};

export default TotalSlideShowScore;
